import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { DateTime } from 'luxon';
import { StoreService } from 'core/services/store.service';
import { LicensesActivityListService } from './licenses-activity-list.service';
import { Group } from 'core/models';

@Component({
  selector: 'lms-licenses-activity-list',
  templateUrl: './licenses-activity-list.component.html',
  styleUrls: ['./licenses-activity-list.component.scss'],
  providers: [LicensesActivityListService]
})
export class LicensesActivityListComponent implements OnChanges, OnDestroy {
  @Input() public group: Group;
  @Input() listId: string;
  @Input() courseId: string;
  @Input() course: any;
  @Input() filteredByGame: boolean;
  @Input() options: any;
  @Input() shouldShowStatus: boolean;
  @Output() public hideSearch: EventEmitter<boolean> = new EventEmitter<boolean>();
  public filters = {};
  public listOptions: any;
  public defaultOptions = {
    filters: this.filters
  };
  public format = DateTime.DATETIME_MED_WITH_SECONDS;
  public dataSource: any;

  constructor(private licensesActivityListService: LicensesActivityListService) {}

  public async ngOnChanges() {
    if (this.courseId) {
      this.listOptions = Object.assign({}, this.defaultOptions, this.options);
      this.dataSource = await this.licensesActivityListService.getDatasource(this.listId, this.listOptions, this.group);

      if (!this.dataSource.docs.length) {
        this.setSortableTable();
      }
    }
  }

  public ngOnDestroy(): void {
    StoreService.remove(this.listId);
  }

  onDatasourceUpdate(dataSource) {
    this.dataSource = dataSource;
    StoreService.update(this.listId, this.dataSource);
  }

  /**
   * Set the sort of columns
   * @private
   */
  private setSortableTable(): void {
    this.hideSearch.emit(true);
    this.dataSource.columns = this.licensesActivityListService.getColumns(this.group, false);
    StoreService.update(this.listId, this.dataSource);
  }
}
